import React from 'react';
import { Calendar, Users, MapPin, Clock } from 'lucide-react';
import { Button } from './ui/button';

export const VisitasClases = () => {
  const scrollToContact = () => {
    const element = document.getElementById('visita');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const opciones = [
    {
      icon: MapPin,
      title: 'Visita al Taller',
      description: 'Recorre el espacio donde nacen las piezas. Conoce a los artesanos, observa el proceso completo desde la arcilla hasta el fuego y entiende por qué esta tradición lleva quinientos años viva.',
      duracion: '1-2 horas',
      ideal: 'Para familias, fotógrafos y viajeros culturales.'
    },
    {
      icon: Users,
      title: 'Clases de Alfarería',
      description: 'Aprende alfarería tradicional de manos de los maestros de El Cercado. Trabaja tu propia pieza desde la arcilla hasta el fuego y llévate a casa algo único, hecho con tus manos y cinco siglos de tradición detrás.',
      duracion: '2-3 horas',
      ideal: 'Para grupos pequeños, principiantes bienvenidos.'
    }
  ];

  return (
    <section id="visitas-clases" className="section-padding bg-background">
      <div className="editorial-container">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="nav-label text-siena">Experiencias</span>
          <h2 className="display-heading text-4xl md:text-5xl lg:text-6xl text-earth mt-4 mb-6">
            Ven a ver
            <br />
            <span className="text-ochre">cómo se hace</span>
          </h2>
          <p className="body-text text-lg">
            El Cercado está a cuarenta minutos de Porlamar. Los talleres están abiertos
            y los artesanos trabajan a la vista. Ven a ver, a aprender o simplemente
            a llevarte una pieza a casa.
          </p>
        </div>

        {/* Opciones Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {opciones.map((opcion, index) => {
            const Icon = opcion.icon;
            return (
              <div
                key={index}
                className="bg-cal-darker rounded-lg p-8 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="w-16 h-16 rounded-full bg-siena/10 flex items-center justify-center mb-6">
                  <Icon className="w-8 h-8 text-siena" />
                </div>
                <h3 className="display-heading text-3xl text-earth mb-4">
                  {opcion.title}
                </h3>
                <p className="body-text text-base leading-relaxed mb-6">
                  {opcion.description}
                </p>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 text-stone">
                    <Clock className="w-4 h-4" />
                    <span>Duración: {opcion.duracion}</span>
                  </div>
                  <div className="flex items-center gap-2 text-stone">
                    <Calendar className="w-4 h-4" />
                    <span>Ideal para: {opcion.ideal}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Image + Info Section */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image */}
          <div className="order-2 md:order-1">
            <img
              src="/images/manos_arcilla.jpg"
              alt="Manos trabajando la arcilla - El Cercado"
              className="w-full h-[400px] md:h-[500px] object-cover rounded-lg shadow-xl"
              loading="lazy"
            />
          </div>

          {/* Info */}
          <div className="order-1 md:order-2 space-y-6">
            <h3 className="display-heading text-3xl md:text-4xl text-earth">
              Una experiencia que no se olvida
            </h3>
            <div className="space-y-4 body-text text-base">
              <p>
                No hay dos visitas iguales. Depende del día, de quién esté trabajando,
                de si hay piezas en el horno o recién salidas del fuego. Lo que siempre
                hay es tiempo para conversar, para entender, para tocar el barro.
              </p>
              <p>
                Las clases son pequeñas y personalizadas. Te llevas algo hecho con tus
                propias manos que tiene peso, historia y sentido.
              </p>
            </div>

            {/* Practical Info */}
            <div className="bg-caribbean/5 border border-caribbean/20 rounded-lg p-6">
              <h4 className="font-medium text-earth mb-3 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-caribbean" />
                Cómo llegar
              </h4>
              <p className="text-sm text-earth-soft leading-relaxed">
                El Cercado, Municipio Gómez · Isla de Margarita, Venezuela
                <br />
                A 40 min de Porlamar por carretera
              </p>
            </div>

            {/* CTA */}
            <Button
              onClick={scrollToContact}
              className="w-full md:w-auto bg-siena hover:bg-siena-dark text-white font-sans text-base uppercase tracking-wider py-6 px-8 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Reservar visita o clase
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
